<template>
   <div id="data-list-list-view" class="data-list-container">
    <vx-card class="p-5  mb-5">
        <div class="vx-row">
            <div class="vx-col lg:w-2/3 w-full"> 
                <p>{{$t('TrainingOrderNumberCourseClass')}}</p>
                  <v-select
                    label="DisplayName"
                    v-model="search.CourseClassID"
                    :options="courseClass"
                    :reduce="value => value.ID"
                  />
              </div>
           
            <vs-button  class="ml-6 mt-5"  @click="loadTrainee" :disabled="!search.CourseClassID">{{$t('LoadTrainee')}}</vs-button>
       </div>
    </vx-card>
    <vx-card class="p-5" >
     <vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="10"  :data="trainees">
        <template slot="thead">
          <vs-th sort-key="Trainee">{{$t('Trainee')}}</vs-th>
          <vs-th sort-key="Attended"> {{$t('Exams')}}</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.FullName }}</p>
              </vs-td>
               <vs-td>
                   <vs-button type="border" color="danger" @click="openExam(tr)">{{$t('Exams')}}</vs-button>

                   </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </vx-card>
   </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import vSelect from 'vue-select'
export default {
    components:{
        Datepicker,
        vSelect
    },
    data(){
        return{
              format:"dd-MM-yyyy",
            search:{}
        }
    },
    computed:{
       
        courseClass(){
            return  this.$store.state.courseClassList.courseClass;
        },
         trainees() {
           debugger;
      return this.$store.state.traineeList.trainees;
    },
        
    },
    methods:{
      openExam(tr)
      {
        this.$router.push('/InstructorTraineeExam/'+tr.ID+'/'+this.search.CourseClassID)
      },
        initValues()
        {
            this.search.CourseClassID="";
         
           this.$store.state.traineeList.trainees=[];
        },
        // submitData()
        // {
        //     var vm=this;
        //     var trainees=this.$store.state.traineeAttendanceList.traineeAttendance.map(function(val){
        //          val.TraineeID=val.Trainee.ID;
        //          val.Trainee=null;
        //         val.CourseClassSessionID= vm.search.SessionID;
        //         return val;
        //     });
        //      this.$store.dispatch("traineeAttendanceList/SaveTraineeAttendance",
        //     trainees
        //      ).then(()=>{
        //            this.initValues();
        //      });
        // },
        loadTrainee()
        {
           
            this.$store.state.courseClassList.search.MarkClassID=this.search.CourseClassID;
            this.$store.dispatch("traineeList/GetTraineeByCourseClassID",this.search.CourseClassID);
        },
        traineeAnswer(traineeID)
        {
            
            this.$store.dispatch("traineeList/GetTraineeByCourseClassID",this.search.CourseClassID);
        },
        formatJsDate(dateToFormat)
        {
            return dateToFormat.getFullYear()+"-"+ (dateToFormat.getMonth()+1)+"-"+dateToFormat.getDate();
        },
    },
    created()
    {
        if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
          if (!moduleCourseClass.isRegistered) {
          this.$store.registerModule("courseClassList", moduleCourseClass);
         moduleCourseClass.isRegistered = true;
       }

       if(this.$store.state.courseClassList.search.MarkClassID!=undefined)
      this.search.CourseClassID= this.$store.state.courseClassList.search.MarkClassID;
      
   
       this.$store.dispatch("courseClassList/GetNotEndCourseClassByInstructorID");

       
    }
}
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
  .vdp-datepicker__calendar
  {
    z-index: 429!important;
  }
</style>